export const checkpointsPlesk = [
  'managerStored',
  'managerSSL',
  'apiStored',
  'apiSSL',
  'notifyStored',
  'notifySSL',
  'terminalsStore',
  'terminalsSSL',
];

export const checkpointsDatabases = ['mongoDB'];

export const checkpointsAcl = ['redisStore', 'mqttStore'];

export const checkpointsInterfaces = ['gitTemplateApi', 'gitTagApi'];

export const checkpointsLaravel = ['laravelInstall', 'laravelToken', 'laravelAdmin'];

export const checkpointsServices = [
  'notifyInstall',
  'terminalsInstall',
  'managerInstall',

  'installFaceServer',
  'installFingerprintServer',
];
export const checkpointsInitialize = ['laravelSynchronize', 'laravelSeeds', 'completed'];
export const checkpoints = [
  ['register'],
  checkpointsPlesk,
  checkpointsDatabases,
  checkpointsAcl,
  checkpointsInterfaces,
  checkpointsLaravel,
  checkpointsServices,
  checkpointsInitialize,
];

export function getCheckpointStep(checkpointName) {
  const resultStep = checkpoints.findIndex((subArray) => subArray.includes(checkpointName));
  return resultStep < 0 ? undefined : resultStep;
}

export function getCompletedCheckpoints(lastCheckpointName) {
  const resultStep = checkpoints.findIndex((subArray) => subArray.includes(lastCheckpointName));
  if (resultStep < 0) return undefined;

  const checkpointIndex = checkpoints[`${resultStep}`].indexOf(lastCheckpointName);
  const lastCheckpoints = checkpoints[`${resultStep}`].slice(0, checkpointIndex + 1);
  return lastCheckpoints;
}
